// Routes ///////////////////////////////////////////////////////////////
export const ShareholdersRoute = (id?: string): string =>
  `/shareholders/securities${id ? `/?search=${id}` : ''}`;
export const DailyChangeRoute = (): string => `/shareholders/daily-change`;

// API //////////////////////////////////////////////////////////////////
export const ShareholdersSummaryUrl = (id): string =>
  `/api/v1/shareholders/security/${id}/summary/`;

export const ModalUrl = (id): string => `/api/v1/shareholders/info/${id}/`;

export const ModalTableUrl = (id): string =>
  `/api/v1/shareholders/${id}/major_securities/`;

export const SecurityUrl = (id, isSimple): string =>
  `/api/v1/shareholders/security/${id}/${isSimple ? 'simple' : 'combined'}/`;

export const ModalActivityUrl = (id, securityId): string =>
  `/api/v1/shareholders/${id}/activity_chart/${securityId}/`;

export const AssetsUrl = (isSimple: boolean): string =>
  `/api/v1/shareholders/assets/${isSimple ? 'simple' : 'combined'}/`;

export const DailyChangesUrl = (isSimple: boolean): string =>
  `/api/v1/shareholders/changes/${isSimple ? 'simple' : 'combined'}/`;

export const SecurityMonthlyChangesUrl = (
  securityId: string,
  isSimple: boolean,
): string =>
  `/api/v1/shareholders/monthly_changes/security/${securityId}/${
    isSimple ? 'simple' : 'combined'
  }/`;

export const ShareholderMonthlyChangesUrl = (shareholderId: number): string =>
  `/api/v1/shareholders/monthly_changes/shareholder/${shareholderId}/`;
